<template>
  <div
    :style="style"
    style="height: 100%; background-size: cover"
    class="d-flex flex-column flex-root"
  >
    <router-view />
    <AuthCodeModal />
  </div>
  <CompanyExpressDataModal />
</template>

<script lang="ts">
import { computed, defineComponent, nextTick, onMounted } from "vue";
import { initializeComponents } from "@/core/plugins/keenthemes";
import AuthCodeModal from "@/components/two-factor-auth/AuthCodeModal.vue";
import { backgroundMain } from "@/core/helpers/config";
import CompanyExpressDataModal from "@/components/modals/CompanyExpressDataModal.vue";

export default defineComponent({
  name: "app",
  components: { CompanyExpressDataModal, AuthCodeModal },
  setup() {
    onMounted(() => {
      nextTick(() => {
        initializeComponents();
      });
    });

    return {
      style: computed(() => ({
        background: `url('${backgroundMain.value}') no-repeat center center fixed`,
      })),
    };
  },
});
</script>

<style lang="scss">
@import "~bootstrap-icons/font/bootstrap-icons.css";
@import "~apexcharts/dist/apexcharts.css";
@import "~quill/dist/quill.snow.css";
@import "~animate.css";
@import "~sweetalert2/dist/sweetalert2.css";
@import "~nouislider/distribute/nouislider.css";
@import "~@fortawesome/fontawesome-free/css/all.min.css";
@import "~dropzone/dist/dropzone.css";
@import "~prism-themes/themes/prism-shades-of-purple.css";
@import "~element-plus/dist/index.css";

// Main demo style scss
@import "assets/sass/plugins";
@import "assets/sass/style";

// Dark mode demo style scss
//@import "assets/sass/plugins.dark";
//@import "assets/sass/style.dark";

//RTL version styles
//@import "assets/css/style.rtl.css";
</style>
